/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 资料，市场活动，资源中心
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
export class MaterialsController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.usersvr_bizNews,
      details: EnumAPI.usersvr_bizNews_details,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: {
          dataSource: 'data',
          total: 'total',
        },
      },
    });
  }
  /**
   * 值存储
   * @memberof MaterialsController
   */
  Model = new BaseModel({ type: 'object' });
  /**
   * @dec 热门课程
   */
  @computed
  get HotCourse(): Array<IEntity> {
    return this.Model.get('HotCourse', []);
  }
  /**
   * @dec 首页政策公告
   */
  @computed
  get Policy(): Array<IEntity> {
    return this.Model.get('Policy', []);
  }
  /**
   * @dec 首页市场活动
   */
  @computed
  get Materials(): Array<IEntity> {
    return this.Model.get('Materials', []);
  }
  /**
   * @dec 首页市场活动视频
   */
  @computed
  get Video(): IEntity {
    return this.Model.get('Video', {});
  }
  /**
   * @dec 首页市场活动视频
   */
  @computed
  get HotVideo(): Array<IEntity> {
    return this.Model.get('HotVideo', []);
  }
  /**
   * @dec 市场资讯列表页热门资讯
   */
  @computed
  get HotInformation(): Array<IEntity> {
    return this.Model.get('HotInformation', []);
  }
  /**
   * @dec 首页优秀合作案例
   */
  @computed
  get GoodCase(): Array<IEntity> {
    return this.Model.get('GoodCase', []);
  }
  /**
   * @dec 即将举行的活动
   */
  @computed
  get Held(): Array<any> {
    return this.Model.get('Held', []);
  }
  /**
   * 获取文件
   * @param id
   * @returns
   */
  onGetFile(id) {
    return AjaxBasics.request({
      ...EnumAPI.usersvr_bizNews_fetch,
      body: { id },
    });
  }

  /**
   * 获取 产品资料 的 热门课程
   */
  async getHotCourse() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_bizNews,
        body: {
          pageSize: 10,
          curPageNo: 1,
          search: {
            nstatus: 1,
            nsectiononeId: 'A004',
            nbu: 'SMB',
            nlabels: '热门',
          },
        },
      });
      this.Model.merge({ HotCourse: lodash.get(res, 'data') });
    } catch (error) {}
  }
  /**
   * 获取 首页政策公告
   */
  async getPolicy() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_bizNews,
        body: {
          pageSize: 5,
          curPageNo: 1,
          search: {
            nsectiononeId: 'A005',
          },
        },
      });
      this.Model.merge({ Policy: lodash.get(res, 'data') });
    } catch (error) {}
  }
  /**
   * 获取 市场活动
   */
  async getMaterials() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_bizNews,
        body: {
          pageSize: 3,
          curPageNo: 1,
          search: {
            nsectiononeId: 'A001',
            nsectiontwoId: 'C008',
          },
        },
      });
      this.Model.merge({ Materials: lodash.get(res, 'data') });
    } catch (error) {}
  }
  /**
   * 获取 市场活动视频
   */
  async getVideo() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_bizNews,
        body: {
          pageSize: 1,
          curPageNo: 1,
          search: {
            nsectiononeId: 'A001',
            nsectiontwoId: 'C009',
          },
        },
      });
      this.Model.merge({ Video: lodash.get(res, 'data[0]', {}) });
    } catch (error) {}
  }
  /**
   * 获取 市场活动 热门 视频
   */
  async getHotVideo() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_bizNews,
        body: {
          pageSize: 10,
          curPageNo: 1,
          search: {
            nbu: 'SMB',
            nsectiononeId: 'A001',
            nsectiontwoId: 'C009',
            nstatus: 1,
            nlabels: '热门',
          },
        },
      });
      this.Model.merge({ HotVideo: lodash.get(res, 'data', []) });
    } catch (error) {}
  }
  /**
   * 获取 优秀合作案例
   */
  async getGoodCase(
    params = {
      pageSize: 3,
      curPageNo: 1,
      search: {
        nsectiononeId: 'A009',
      },
    },
  ) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_bizNews,
        body: { ...params },
      });
      this.Model.merge({ GoodCase: lodash.get(res, 'data') });
    } catch (error) {}
  }
  /**
   * 获取 首页 活动预告
   */
  async getHeld() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_commingActivityList,
        body: {
          curPageNo: 1,
          pageSize: 10,
        },
      });
      // this.Model.merge({ Held: lodash.get(res, "recordList", {}) });
      this.Model.merge({ Held: lodash.get(res, 'data') });
    } catch (error) {}
  }
  /**
   * 获取 市场资讯 热门
   */
  async getHotInformation() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.usersvr_bizNews,
        body: {
          pageSize: 4,
          curPageNo: 1,
          search: {
            nsectiononeId: 'A001',
            nstatus: 1,
            nlabels: '热门',
          },
        },
      });
      this.Model.merge({ HotInformation: lodash.get(res, 'data') });
    } catch (error) {}
  }
}

interface IEntity {
  beginTime: string;
  columnType: string;
  createBy: string;
  createBy1: string;
  createTime: string;
  createTime1: string;
  currentUser: string;
  dataScope: string;
  delFlag: string;
  delFlag1: string;
  endTime: string;
  id: string;
  idType: string;
  modifyBy: string;
  modifyTime: string;
  modifyTime1: string;
  ncontent: string;
  nfiles: string;
  nfilesWatermark: string;
  nistop: number;
  nlabels: string;
  nsectiononeId: string;
  nsectiononeName: string;
  nsectionthreeId: string;
  nsectionthreeName: string;
  nsectiontwoId: string;
  nsectiontwoName: string;
  nstatus: number;
  nsubtitle: string;
  nthumbnailImage: string;
  nthumbnailImagePc: string;
  ntitle: string;
  remarks: string;
  stringList: string;
}
